// extracted by mini-css-extract-plugin
export var doneButton = "SkrillEmailStep-module--doneButton--4c130";
export var explainer = "SkrillEmailStep-module--explainer--f6ede";
export var options = "SkrillEmailStep-module--options--27a90";